export default {
  title: 'Create new company',
  backButton: 'All companies',
};
